export default __webpack_public_path__ + "04405f7a23f9221adfd4f69179ce3d10.svg";